import React, { useEffect, useState } from "react";//added approval button,modal and included its functions
import { useNavigate } from "react-router-dom";
import strings from "translate/language";
import { getSourcingManagerList} from '../../reduxStore/action/sourcingManagerAction'
import { useDispatch, useSelector } from "react-redux";
import TableDataNotFound from "component/TableDataNotFound";
import { handleListResponse, seo } from "utils/utils";
import Breadcrumb from "component/common/breadcrumb";
import usePermission from "utils/usePermission";
import { getAssignCPList,removeCpList } from "reduxStore/action/channelPartnerAction";
import moment from "moment";
import Select from "react-select";
import Button from "component/Button";
import AllocateCP from "./AllocateCp"


const SourcingManagerList = () => {
  
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [sourcingManagerList, setSourcingManagerList] = useState([]);
  const [selectedItem,setSelectedItem] = useState(null)
  const [getchannelPartnerList, setchannelPartnerList] = useState([]);
  const [modalShow, setModalShow] = useState(false);
 
  const sourcingManagerSelecter = useSelector(
    (state) => state?.smData
  );
  const channelPartnerListSelector = useSelector(
    (state) => state?.channelPartner
  );




    const {response:res} = useSelector((state) => state.login)

  
  const { view } = usePermission({
    view: "sourcing_manager",
  });


 
  const navigatpage = async (navname) => {
    navigate(navname);
  };


  useEffect(() => {
    dispatch(getSourcingManagerList({}));
    dispatch(removeCpList());
  }, [dispatch]);



  useEffect(() => {
    const { response = null, create = false } = sourcingManagerSelecter;
    if (response && response?.status === 200) {

      if (!create && response.data?.length > 0) {
        setSourcingManagerList(
          handleListResponse(response?.data) ? response?.data : []
        );
      }
    } else {
      setSourcingManagerList([]);
    }
  }, [sourcingManagerSelecter]);

   
useEffect(() => {
    const { response = null, create = false } = channelPartnerListSelector;
    if (response && response?.status === 200) {

      if (!create && response.data?.length > 0) {
        setchannelPartnerList(
          handleListResponse(response?.data) ? response?.data : []
        );
      }
    } else {
      setchannelPartnerList([]);
    }
  }, [channelPartnerListSelector]);
  


  const openApprovalModal=(item)=>{
    setModalShow(true);
    dispatch(getAssignCPList({ user_id: item?._id}))
    setSelectedItem(item)
  }

  const handleCloseModal = () => {
    dispatch(removeCpList());
    setModalShow(false);
    setSelectedItem(null)
  };
  
  return (
    <div className="page-body">
      {/* Model_start */}
    
      {/* Model_end */}
      <Breadcrumb
        title={strings.sourcingManager}
        titleactive={strings.sourcingManagerListing}
      />
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12 col-xl-12">
            
            <div className="row">
              <div className="col-sm-12 col-xl-12">
                <div className="card">
                  <div  className="card-header">
                    <h5>{strings.sourcingManagerList}</h5>
                  </div>
                  <div className="table-responsive">
                    <table className="table table-border-horizontal">
                      <thead className="text-center">
                        <tr>
                          <th scope="col">{strings.name}</th>
                          <th scope="col">{strings.noOfLeads}</th>
                          <th scope="col">{strings.noOfSiteVisits}</th>
                         
                          <th scope="col">{strings.noBookings}</th>
                          <th scope="col">{strings.conversionPercentage}</th>
                          <th scope="col">{strings.action}</th>
                        </tr>
                      </thead>
                      <tbody className="text-center">
                        {sourcingManagerList?.length > 0 ? (
                          sourcingManagerList.map((item, index) => {
                            return (
                              <tr key={item._id}>
                                <td style={{ inlineSize: "130px" }}>
                                  {item?.user_name}
                                </td>
                                <td>{item.total_visit}</td>
                                
                                <td>{item.total_site_visit}</td>
                                <td>
                                  {item.total_closing_lead}
                                </td>
                                <td>{item.total_closing_percentage}</td>
                               
                               
                                <td className="p-2">
                                  {view && (
                                      <>
                                    <i
                                      className="fa fa-eye theme-fa-icon p-2"
                                      aria-hidden="true"
                                      title={strings.viewSourcingManager}
                                      onClick={() => {
                                        navigatpage(
                                          `/viewSourcingManager/${item._id}`
                                        );
                                      }}
                                    ></i>
                                  
                                    <button
                                        type="button"
                                        onClick={() => openApprovalModal(item)}
                                        className="btn-sm mt-1"
                                        style={{
                                        color: "violet", // Green for active, red for deactivated
                                        borderColor: "violet", // Same logic for border color
                                        backgroundColor: "white",
                                        display: "inline-block", // Display inline for side-by-side buttons
                                        }}
                                    >
                                        {strings.allocateCp}
                                    </button>
                                    {modalShow && selectedItem._id === item?._id &&
                                     <AllocateCP
                                     show={modalShow}
                                     smData={selectedItem}
                                     AllCps={getchannelPartnerList}
                                     handleClose={handleCloseModal}
                                   />
                                   }
                                    </>
                                  )}
                                  
                                  {/* {edit && (
                                    <i
                                      className="fa fa-edit theme-fa-icon "
                                      aria-hidden="true"
                                      title={strings.editSourcingManager}
                                      onClick={() => {
                                        navigatpage(
                                          `/edit_sourcing_manager?cm_id=${item._id}`
                                        );
                                      }}
                                    ></i>
                                  )} */}
                                  
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr />
                        )}
                      </tbody>
                      {/* <i
                                    className="fa fa-edit theme-fa-icon"
                                    aria-hidden="true"
                                    data-toggle="modal"
                                    data-original-title="test"
                                    data-target="#exampleModal1"
                                    title="Allocation"
                                    onClick={() => {
                                      dispatch(
                                        cpCurrentMaping({
                                          agency_id: item?.login_id,
                                        })
                                      );
                                    }}
                                  ></i> */}
                    </table>
                    <TableDataNotFound data={sourcingManagerList} />
                  </div>
             
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
        
    </div>
  );
};
export default SourcingManagerList;
